export default "__VITE_ASSET__DG4wjzGF__"